import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Swiper core styles
import "swiper/css/pagination"; // Swiper pagination styles

const InstagramSection = () => {
  // Array of Instagram images with paths relative to the public directory
  const images = [
    '/images/ourfleet/8.jpg',
    '/images/ourfleet/2.jpg',
    '/images/ourfleet/3.jpg',
    '/images/ourfleet/4.jpg',
    '/images/ourfleet/5.jpg',
    '/images/ourfleet/6.jpg',
    '/images/ourfleet/7.jpg',
  
    // '/img/instagram/insta-post-1-4.png',
  ];

  // Fallback image URL
  const fallbackImage = '/img/instagram/placeholder.png'; // Placeholder image if the real image is missing

  // Function to handle image loading errors and display a fallback image
  const handleImageError = (e) => {
    e.target.src = fallbackImage; // Use the fallback image if the original image fails to load
  };

  return (
    <div className="instagram-style1 space-top py-5">
      <div className="container">
        <div className="row">
          <div className="col-lg-auto mx-auto">
            <div className="title-area text-center">
              <span className="sec-subtitle fade-anim" data-direction="bottom">
                Our vehicle
              </span>
              <h2 className="sec-title fade-anim" data-direction="top">
                Our Fleets
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid p-0 overflow-hidden">
        <div className="row">
          <div className="col-12">
            <Swiper
              spaceBetween={30} // Space between each slide
              slidesPerView={3} // Show 3 slides at once
              loop={true} // Infinite loop
              autoplay={{ delay: 3000 }} // Autoplay every 3 seconds
              breakpoints={{
                0: {
                  slidesPerView: 1, // On mobile, show 1 slide
                },
                768: {
                  slidesPerView: 2, // On tablet, show 2 slides
                },
                1200: {
                  slidesPerView: 3, // On desktop, show 3 slides
                },
              }}
              className="swiper-container instagram-slider"
            >
              {/* Instagram post slides */}
              {images.map((image, index) => (
                <SwiperSlide key={index}>
                  <div className="instagram-box borderr">
                    <div className="insta-post-thumb">
                      <img
                        src={image}
                        alt={`instagram-post-${index}`}
                        className="w-100"
                        onError={handleImageError} // Handle error to show fallback image
                      />
                    </div>
                    <div className="insta-post-content">
                      <a
                        href="/our-fleet"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa-solid fa-link"></i>
                      </a>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstagramSection;
